<template>
  <ChecklistItem
    title="2. List your area's of expertise"
    description="This will help others to discover you in the inspiration creator community"
    :is-done="isDone"
    :editing="editing"
    @edit="startEdit"
    @done="finishEdit"
  >
    <template #default>
      <iColumn gap="standard">
        <iSubHeading font-size="standard">
          Check all that apply:
        </iSubHeading>
        <iColumn gap="small" width="fill">
          <iCheckbox
            v-for="area in expertiseAreas"
            :key="area.id"
            v-model="area.selected"
            :label="area.label"
            :is-loading="isLoadingToggleExpertiseArea(area.id)"
            @change="updateExpertiseArea(area.id)"
          />
        </iColumn>
      </iColumn>
    </template>
    <template #pitch>
      <iText font-size="standard">
        Tell the community what you're great at so people know how to hire you.
      </iText>
    </template>
    <template #summary>
      <iSubHeading font-size="standard">
        I am an expert in...
      </iSubHeading>
      <iColumn gap="small" width="fill">
        <iText font-size="standard">
          {{ selectedAreas }}
        </iText>
      </iColumn>
    </template>
  </ChecklistItem>
</template>

<script>
import { EXPERTISE_AREAS } from "@/constants/expert-constants";
import { mapActions, mapState } from "pinia";
import { useExpertServicePackageStore } from "@/stores/expert-service-package-store";
import { useGeneralStore } from "%/stores/general-store";
import ChecklistItem from "@/components/onboarding/ChecklistItem.vue";

export default {
  name: "ExpertiseChecklist",
  components: { ChecklistItem },
  data() {
    return {
      expertiseAreas: EXPERTISE_AREAS.map(area => ({
        ...area,
        selected: false,
      })),
      editing: false,
    };
  },
  computed: {
    ...mapState(useExpertServicePackageStore, [
      "expertPackageModalOpen",
      "activeExpertIds",
      "isLoadingAddExpert",
      "isLoadingRemoveExpert",
      "currentExpertiseId",
    ]),
    ...mapState(useGeneralStore, ["orgId"]),
    isDone() {
      return this.expertiseAreas.some(area => area.selected);
    },
    selectedAreas() {
      return this.expertiseAreas
          .filter(area => area.selected)
          .map(area => area.label)
          .join(", ");
    },
  },
  mounted() {
    this.initializeExpertiseAreas();
  },
  methods: {
    ...mapActions(useExpertServicePackageStore, [
      "openExpertPackageModal",
      "addOrgExpertise",
      "removeOrgExpertise",
    ]),

    startEdit() {
      this.editing = true;
    },

    finishEdit() {
      this.editing = false;
    },

    isLoadingToggleExpertiseArea(expertiseId) {
      const isCurrentExpertiseId = expertiseId === this.currentExpertiseId;
      return (
        isCurrentExpertiseId &&
          (this.isLoadingAddExpert || this.isLoadingRemoveExpert)
      );
    },


    initializeExpertiseAreas() {
      this.expertiseAreas.forEach(area => {
        area.selected = this.activeExpertIds.includes(area.id);
      });
    },

    updateExpertiseArea(expertId) {
      const area = this.expertiseAreas.find(area => area.id === expertId);

      if (area.selected) {
        this.addOrgExpertise(this.orgId, expertId);
      } else {
        this.removeOrgExpertise(this.orgId, expertId);
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
